import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["name", "value"]

import TandemInputWrapper from "@/components/TandemInputWrapper.vue";
import type { Props as WrapperProps } from "@/components/TandemInputWrapper.vue";

interface Props extends WrapperProps {
  modelValue?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TandemTextInput',
  props: {
    modelValue: {},
    errors: {},
    name: {},
    label: {},
    helpText: {},
    labelExtraClasses: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {



const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  emit("update:modelValue", input.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TandemInputWrapper, {
    name: _ctx.name,
    label: _ctx.label,
    "help-text": _ctx.helpText,
    required: _ctx.required,
    errors: _ctx.errors
  }, {
    default: _withCtx(() => [
      _createElementVNode("input", _mergeProps({
        type: "text",
        name: _ctx.name
      }, _ctx.$attrs, {
        value: _ctx.modelValue,
        onInput: handleInput
      }), null, 16, _hoisted_1)
    ]),
    _: 1
  }, 8, ["name", "label", "help-text", "required", "errors"]))
}
}

})